module.exports = __webpack_public_path__ + "static/media/LabResultsQuestion.0222439c.png";